import React, {FC} from 'react';

import {ChatView} from '../ChatView/ChatView';
import {Chat} from '../ChatView/types';

export interface CallChatProps {
  chat: Chat;
  showTitle?: boolean;
}

/**
 * CallChat renders pre-processed, deduplicated chat data.
 *
 * This component receives fully processed chat data that has already been:
 * - Converted from call format via useCallAsChat
 * - Deduplicated across all turns in the thread
 * - Grouped and sorted by turn and timestamp
 *
 * @param chat - The processed and deduplicated chat data to display
 * @param showTitle - Whether to show section titles
 *
 * @example
 * <CallChat chat={deduplicatedChat} showTitle={false} />
 */
export const CallChat: FC<CallChatProps> = ({chat, showTitle = false}) => {
  // Skip rendering if chat lacks required message data
  if (!chat.request || !chat.request.messages) {
    return null;
  }

  return <ChatView chat={chat} showTitle={showTitle} autoScroll={false} />;
};
